import styled, {css} from "styled-components";
import React, {useState} from "react";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper/BreakpointHelper";

export const FormCounter = ({
                                label = 'label',
                                additionalLabel = '',
                                initialCount = 0,
                                margin = '0px',
                                counterCallback,
                                name = '',
                                minAmount
                            }) => {
    const [counter, setCounter] = useState(initialCount);
    const [isDisables, setIsDisabled] = useState((minAmount && initialCount === minAmount) || !initialCount);
    return (
        <CounterWrapper margin={margin}>
            <LabelWrapper>
                <CounterLabel>{label}</CounterLabel>
                {additionalLabel ? <AdditionalLabel>{additionalLabel}</AdditionalLabel> : null}
            </LabelWrapper>
            <Wrapper>
                <CounterButton disabled={isDisables} onClick={(e) => {
                    e.preventDefault();
                    if (counter) {
                        const currentCounter = counter - 1;
                        setCounter(currentCounter);
                        counterCallback && counterCallback({field: name, count: currentCounter});
                        if ((minAmount && minAmount === currentCounter) || !currentCounter) {
                            setIsDisabled(true);
                        }
                    }
                }}>
                    <i className="fas fa-minus" aria-hidden="true"></i>
                </CounterButton>
                <Counter>{counter}</Counter>
                <CounterButton onClick={(e) => {
                    e.preventDefault();
                    if (isDisables) {
                        setIsDisabled(false);
                    }
                    const currentCounter = counter + 1;
                    setCounter(currentCounter);
                    counterCallback && counterCallback({field: name, count: currentCounter});
                }}>
                    <i className="fas fa-plus" aria-hidden="true"></i>
                </CounterButton>
            </Wrapper>
        </CounterWrapper>
    )
}

export const CounterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 220px;
    margin: ${({margin}) => margin};
    row-gap: 8px;

    ${media.lessThan(breakpoints.mobile)`
        max-width: 100%;
        width: auto;
    `}
`;

export const LabelWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const AdditionalLabel = styled.label`
    font-weight: 400;
`;

export const CounterLabel = styled.label`
    font-weight: 600;
`;

export const CounterButton = styled.button.attrs(({ariaLabel}) => ({
    "aria-label": ariaLabel || "counter button",
}))`
    display: flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    color: #000;
    border-radius: 50%;
    border: 0;
    font-size: 20px;
    background: ${({theme}) => theme.colors.bg1};
    transition: .5s;

    &:hover {
        cursor: pointer;
        background: ${({theme}) => theme.colors.primary};

        i {
            color: #fff;
        }
    }

    &:focus {
        outline: none;
    }

    i {
        font-size: 20px;
    }

    ${({disabled}) => disabled &&
            css`
                background: #F5F5F5;

                &:hover {
                    cursor: not-allowed;
                    background: #F5F5F5;

                    i {
                        color: #949494;
                    }
                }

                i {
                    color: #949494;
                }
            `}
`;

export const Counter = styled.div`
    display: flex;
    min-width: 98px;
    flex: 1;
    color: #000;
    align-items: center;
    justify-content: center;
    border: 0.063rem solid #949494;
    border-radius: 24px;
    font-size: 1.25rem;
    line-height: 21px;
    font-family: "museo-sans";
    height: 100%;
`;

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    height: 48px;
`;
